import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Observable, of, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {TABLE_TYPE} from 'src/app/models/column-config';
import {ProductHistory} from 'src/app/models/history';
import {ProductService} from '../../../product-view-module/services/product.service';

@Component({
  selector: 'app-product-history',
  templateUrl: './product-history.component.html',
  styleUrls: ['./product-history.component.sass']
})
export class ProductHistoryComponent implements OnInit, OnDestroy {
  @Input() public smartNumber: string;

  public readonly TABLE_TYPE: typeof TABLE_TYPE = TABLE_TYPE;

  public productHistory$: Observable<ProductHistory[]> = of(null);

  private onComponentDestroyed$: Subject<void> = new Subject();

  constructor(private productService: ProductService) {
  }

  ngOnInit(): void {
    this.productHistory$ = this.productService.getProductEditHistoryBySN(this.smartNumber).pipe(takeUntil(this.onComponentDestroyed$));
  }

  ngOnDestroy(): void {
    this.onComponentDestroyed$.next();
    this.onComponentDestroyed$.complete();
    this.onComponentDestroyed$.unsubscribe();
  }
}
